import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filter, has, pickBy, size, toLower, toUpper } from "lodash";
import { changeDates, clearRule, getShcNodes, getShcResult, getShcResults, getShcRule, includePassed, resetData, showOnlyFailed } from "../../store/shcSlice";
import { Shc } from "./Shc";
import { ShcRule } from "./ShcRule";
import { ShcUploadWrapper } from "./ShcUploadWrapper";
import { uploadShcFile } from "../../store/uploadSlice";
import { Page403 } from "../../components/Page403";


const ShcContainer = ({ location, match, history }) => {
    const dispatch = useDispatch();
    const { pathname } = location;
    const { node, file } = match.params;
    const { nodes, results, dates, interval, onlyFailed, result, includingPassed, rule, notFound, forbidden } = useSelector(state => ({
        ...state.shc,
        results: state.shc.onlyFailed ? filter(state.shc.results, x => x.failed > 0) : state.shc.results
    }));
    const { details } = useSelector(state => state.data);
    const { shcRead, shcWrite } = useSelector(state => state.user.grants);
    const uploadsCount = useSelector(state => Object.keys(pickBy(state.upload.uploads, up => has(up, "type") && up.status == 0)).length);
    const uploadsRef = useRef();
    const urlParams = Object.keys(match.params);
    const showFiles = urlParams.includes("file");
    const defaultPath = "/services/shc/nodes";

    const breadcrumbs = [
        {
            title: "Services",
            href: "/services"
        },
        {
            title: node || urlParams.includes("upload") ? "Recent Data" : "Recent tests results by nodes",
            href: defaultPath
        }
    ];
    if (node) {
        breadcrumbs.push({
            title: toUpper(node),
            href: file ? defaultPath + "/" + node : null
        });
        if (file) {
            breadcrumbs.push({ title: "Upload data" });
        }
    };

    useEffect(() => {
        return () => dispatch(resetData());
    }, [])

    useEffect(() => {
        if (shcRead) {
            if (file) {
                dispatch(getShcResult(file));
            } else if (node) {
                dispatch(getShcResults(node));
            } else {
                dispatch(getShcNodes());
            };
        };
    }, [ shcRead, node, file ]);

    useEffect(() => {
        if (node) {
            dispatch(getShcResults(node));
        }
    }, [ dates[0], dates[1]] );

    useEffect(() => {
        if (Array.isArray(nodes) && nodes.length) {
            dispatch(getShcResults());
        }
    }, [ nodes ]);

    useEffect(() => {
        if (uploadsCount > uploadsRef.current) {
            if (node) {
                if (!file) dispatch(getShcResults(node));
            } else {
                dispatch(getShcNodes());
            }
        }
        uploadsRef.current = uploadsCount;
    }, [ uploadsCount ]);

    const onSwitchMode = () => {
        if (node) {
            if (showFiles) {
                history.push(defaultPath + "/" + toLower(node));
            } else {
                history.push(defaultPath + "/" + toLower(node) + "/files");
            }
        }
    }

    if (forbidden) {
        return <Page403 />
    };

    const component = <>
        <Shc
            node={node}
            nodes={nodes}
            data={results}
            dates={dates}
            interval={interval}
            pathname={defaultPath}
            onlyFailed={onlyFailed}
            showOnlyFailed={value => dispatch(showOnlyFailed(value))}
            onDateChange={values => dispatch(changeDates(values))}
            showFiles={showFiles}
            onSwitchMode={onSwitchMode}
            file={file}
            result={result}
            showPassed={includingPassed}
            onShowPassed={value => dispatch(includePassed(value))}
            breadcrumbs={breadcrumbs}
            dashboard={pathname === defaultPath}
            onChartBarClick={(node, file) => history.push(defaultPath + "/" + toLower(node) + "/files/" + file)}
            shcWrite={shcWrite}
            onShowRule={(rule) => dispatch(getShcRule(rule))}
            upload={details}
            uploadFile={({ file }) => dispatch(uploadShcFile(file))}
            shcRead={shcRead}
            notFound={notFound}
        />
        {size(rule)
            ? <ShcRule onClose={() => dispatch(clearRule())} data={rule} />
            : null}
    </>


    return shcWrite
        ? <ShcUploadWrapper uploadFile={({ file }) => dispatch(uploadShcFile(file))}>{component}</ShcUploadWrapper>
        : component
}

export { ShcContainer }